import React, { useEffect } from 'react';
import './App.css';
import Router from './router';
import store from './store';
import { initFromStorage } from './actions/LoginAction';
import Alert from './component/Alert';

const App = () => {
  useEffect(() => {
    async function fetchSelf() {
      await store.dispatch(initFromStorage());
    }

    fetchSelf();
  }, []);

  return (
    <div className="App">
      <Router />
      <Alert />
    </div>
  );
};

export default App;
